// Campus photo for /colleges/university-of-la-verne: CC BY-SA 4.0, by Dylang140, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_La_Verne.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-la-verne/; credited under the photo.
const photo = {
    "slug": "university-of-la-verne",
    "alt": "The Athletics Pavilion, Campus Center and Citrus Hall on the University of La Verne campus in La Verne, California",
    "src": "/colleges/university-of-la-verne/campus-1600.webp",
    "srcSmall": "/colleges/university-of-la-verne/campus-800.webp",
    "srcMid": "/colleges/university-of-la-verne/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-la-verne/og.jpg",
    "title": "University of La Verne",
    "author": "Dylang140",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_La_Verne.jpg",
    "read": "2026-10-02"
};

export default photo;
